module.exports = __webpack_public_path__ + "img/bir.65cb5a0d.png";